import styled from 'styled-components'

const PlusSign = styled.span`
  font-size: 48px;
  line-height: 0;
  margin-bottom: 5px;
`

const EditButtons = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`
export default {
  PlusSign,
  EditButtons,
}
